import Row from '@sdk/components/ui/spacing/Row';
import HorizontalSeparator from '@sdk/components/ui/HorizontalSeparator';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { AttestationOption } from '@sdk/automatedBreaks/types/Attestation';

import TimeClockRow from '@web/timesheets/CreateTimesheetModal/components/rows/TimeClockRow/TimeClockRow';
import BreakRow from '@web/timesheets/CreateTimesheetModal/components/rows/BreakRow/BreakRow';
import AddBreakButton from '@web/timesheets/CreateTimesheetModal/components/TimeClockSections/AddBreakButton';
import TimeClockSectionErrors from '@web/timesheets/CreateTimesheetModal/components/TimeClockSections/TimeClockSectionErrors';
import { useTimeClockSection } from '@web/timesheets/CreateTimesheetModal/components/TimeClockSections/timeClockSection.hooks';
import { TimeClockSectionProps } from '@web/timesheets/CreateTimesheetModal/components/TimeClockSections/timeClockSection.types';

const TimeClockSection = ({
  timeClockFieldSet,
  submitErrors,
  setSubmitErrors,
  isLastSection,
  isRemovable,
  remove,
  scheduledShiftStart,
  breakAttestations,
  askForExcessiveBreaksConfirmation,
  chooseAttestationToReplace,
}: TimeClockSectionProps) => {
  const { addBreak, updateBreak, removeBreak, visibleBreaks, breaksFieldError } =
    useTimeClockSection({
      timeClockFieldSet,
      submitErrors,
      setSubmitErrors,
    });

  const entryHasAttestations = breakAttestations.some(
    ({ baseSequenceId }) => baseSequenceId === timeClockFieldSet.baseSequenceId?.value
  );

  const preventedAttestations = breakAttestations.filter(
    ({ baseSequenceId, option }) =>
      baseSequenceId === timeClockFieldSet.baseSequenceId?.value &&
      option === AttestationOption.prevented
  );

  return (
    <>
      <TimeClockRow
        timeClockFieldSet={timeClockFieldSet}
        isRemovable={isRemovable}
        remove={remove}
        scheduledShiftStart={scheduledShiftStart}
      />

      {visibleBreaks.map((breakValue, index) => (
        <BreakRow
          key={breakValue.key}
          breakValue={breakValue}
          fieldError={breaksFieldError}
          submitBreakError={submitErrors?.breaks?.[timeClockFieldSet.key.value]?.[breakValue.key]}
          isLastEntry={visibleBreaks.length - 1 === index}
          remove={removeBreak}
          update={updateBreak}
          timeClockFieldSet={timeClockFieldSet}
        />
      ))}

      <TimeClockSectionErrors
        submitErrors={submitErrors}
        timeClockEntryKey={timeClockFieldSet.key.value}
      />

      <AddBreakButton
        timeClockEntryKey={timeClockFieldSet.key.value}
        addBreak={addBreak}
        entryHasAttestations={entryHasAttestations}
        preventedAttestations={preventedAttestations}
        askForExcessiveBreaksConfirmation={askForExcessiveBreaksConfirmation}
        chooseAttestationToReplace={chooseAttestationToReplace}
        existingBreaks={timeClockFieldSet.breaks.value}
      />

      <Row mTop={10} mBottom={isLastSection ? 0 : 10}>
        <HorizontalSeparator themeColor={ThemeColorType.separatorOnGray} />
      </Row>
    </>
  );
};

export default TimeClockSection;
